/* eslint-disable @typescript-eslint/no-explicit-any */
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FilterDropDownsModule } from '@vfde-fe/ngx-lib/components/filter-dropdowns';
import { HtmlTemplateModule } from '@vfde-fe/ngx-lib/components/html-template';
import { NavigationModule } from '@vfde-fe/ngx-lib/components/navigation';
import { NotificationModule } from '@vfde-fe/ngx-lib/components/new-notification';
import { SpinnerModule } from '@vfde-fe/ngx-lib/components/spinner';
import { TrackingIconModule } from '@vfde-fe/ngx-lib/components/tracking-icon';
import { FallbackTranslatePipeModule } from '@vfde-fe/ngx-lib/pipes/fallback-translate';
import { OrderByPipeModule } from '@vfde-fe/ngx-lib/pipes/order-by';
import { StringConverterPipeModule } from '@vfde-fe/ngx-lib/pipes/string-converter';
import { TrimPipeModule } from '@vfde-fe/ngx-lib/pipes/trim';
import { NgxPaginationModule } from 'ngx-pagination';
import { ConfigLoaderService } from './services/config-loader.service';
import { ViewContainerDirective } from 'src/app/shared/directives/view-container/view-container.directive';

/** WS10 Modules */
import { WS10HeadlineModule } from '@vfde-fe/ngx-lib/brix/ws10-headline';
import { WS10ButtonModule } from '@vfde-fe/ngx-lib/brix/ws10-button';
import { WS10ListCardModule } from '@vfde-fe/ngx-lib/brix/ws10-list-card';
import { WS10ListCardWrapperModule } from '@vfde-fe/ngx-lib/brix/ws10-list-card-wrapper';
import { WS10SearchInputModule } from '@vfde-fe/ngx-lib/brix/ws10-search-input';
import { WS10TextHeaderModule } from '@vfde-fe/ngx-lib/brix/ws10-text-header';
import { Ws10PaginationModule } from '@vfde-fe/ngx-lib/brix/ws10-pagination';
import { WS10GridModule } from '@vfde-fe/ngx-lib/brix/ws10-grid';
import { WS10GridContainerModule } from '@vfde-fe/ngx-lib/brix/ws10-grid-container';
import { Ws10CaptchaModule } from '@vfde-fe/ngx-lib/brix/ws10-captcha';
import { WS10FormCheckboxModule } from '@vfde-fe/ngx-lib/brix/ws10-form-checkbox';
import { WS10RadioButtonModule } from '@vfde-fe/ngx-lib/brix/ws10-radio-button';
import { Ws10FormElementBlockModule } from '@vfde-fe/ngx-lib/brix/ws10-form-element-block';
import { WS10ButtonLinkModule } from '@vfde-fe/ngx-lib/brix/ws10-button-link';
import { WS10ParagraphModule } from '@vfde-fe/ngx-lib/brix/ws10-paragraph';
import { WS10NotificationModule } from '@vfde-fe/ngx-lib/brix/ws10-notification';
import { WS10NotificationIconModule } from '@vfde-fe/ngx-lib/brix/ws10-notification-icon';
import { WS10UploadModule } from '@vfde-fe/ngx-lib/brix/ws10-upload'

/** Components */
import { GeneralErrorComponent } from './shared-components/general-error/general-error.component';
import { CenterHubComponent } from './shared-components/center-hub/center-hub.component';
import { FormEditorComponent } from './shared-components/form-editor/form-editor.component';
import { GenericMessageComponent } from 'src/app/shared/shared-components/generic-message/generic-message.component';
import { ConfirmationComponent } from 'src/app/shared/shared-components/confirmation/confirmation.component';
import { CheckboxComponent } from 'src/app/shared/shared-components/checkbox/checkbox.component';
import { RadioButtonComponent } from 'src/app/shared/shared-components/radio-button/radio-button.component';
import { SelectBlockComponent } from 'src/app/shared/shared-components/select-block/select-block.component';
import { TextInputBlockComponent } from 'src/app/shared/shared-components/text-input-block/text-input-block.component';
import { TextAreaBlockComponent } from 'src/app/shared/shared-components/text-area-block/text-area-block.component';
import { HeadlineComponent } from 'src/app/shared/shared-components/headline/headline.component';
import { ButtonLinkComponent } from 'src/app/shared/shared-components/button-link/button-link.component';
import { ParagraphComponent } from 'src/app/shared/shared-components/paragraph/paragraph.component';
import { UploadComponent } from 'src/app/shared/shared-components/upload/upload.component';

/** SharedModule */
@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        ReactiveFormsModule,
        NgxPaginationModule,
        TranslateModule.forChild(),
        NavigationModule,
        NotificationModule,
        SpinnerModule,
        TrackingIconModule,
        TrimPipeModule,
        FilterDropDownsModule,
        OrderByPipeModule,
        HtmlTemplateModule,
        FallbackTranslatePipeModule,
        StringConverterPipeModule,
        WS10HeadlineModule,
        WS10ButtonModule,
        WS10ListCardModule,
        WS10ListCardWrapperModule,
        WS10SearchInputModule,
        WS10TextHeaderModule,
        WS10GridModule,
        WS10GridContainerModule,
        Ws10PaginationModule,
        Ws10CaptchaModule,
        WS10FormCheckboxModule,
        WS10RadioButtonModule,
        Ws10FormElementBlockModule,
        WS10ButtonLinkModule,
        WS10ParagraphModule,
        WS10NotificationModule,
        WS10NotificationIconModule,
        WS10UploadModule,
    ],
    declarations: [
        GeneralErrorComponent,
        GenericMessageComponent,
        ConfirmationComponent,
        CenterHubComponent,
        FormEditorComponent,
        ViewContainerDirective,
        CheckboxComponent,
        RadioButtonComponent,
        SelectBlockComponent,
        TextInputBlockComponent,
        TextAreaBlockComponent,
        HeadlineComponent,
        ButtonLinkComponent,
        ParagraphComponent,
        UploadComponent,
    ],
    exports: [
        TranslateModule,
        FormsModule,
        CommonModule,
        ReactiveFormsModule,
        NgxPaginationModule,
        NavigationModule,
        NotificationModule,
        SpinnerModule,
        TrackingIconModule,
        TrimPipeModule,
        FilterDropDownsModule,
        OrderByPipeModule,
        HtmlTemplateModule,
        FallbackTranslatePipeModule,
        StringConverterPipeModule,
        GenericMessageComponent,
        ConfirmationComponent,
        ViewContainerDirective,
        CheckboxComponent,
        RadioButtonComponent,
        TextAreaBlockComponent,
        TextInputBlockComponent,
        SelectBlockComponent,
        HeadlineComponent,
        ButtonLinkComponent,
        ParagraphComponent,
        UploadComponent,
    ],
})
/** SharedModule */
export class SharedModule {
    /** forRoot */
    public static forRoot (): ModuleWithProviders<any> {
        return {
            ngModule: SharedModule,
            providers: [
                ConfigLoaderService,
            ],
        };
    }
}
